// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideMenu_home__Hn3Ra {
    height: 32px;
    margin: 16px;
    background: rgba(255, 255, 255, .2);
    border-radius: 6px;
}

.SideMenu_home_butn__m1XKM {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    font-size: 20px;
    color: #fff;
    cursor: pointer;
}

.SideMenu_home_butn__m1XKM:hover {
    background: rgba(255, 255, 255, .3);
}

.SideMenu_home_butn__m1XKM:active {
    background: rgba(255, 255, 255, .4);
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/SideMenu/index.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,YAAY;IACZ,mCAAmC;IACnC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,mCAAmC;AACvC","sourcesContent":[".home {\n    height: 32px;\n    margin: 16px;\n    background: rgba(255, 255, 255, .2);\n    border-radius: 6px;\n}\n\n.home_butn {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    font-size: 20px;\n    color: #fff;\n    cursor: pointer;\n}\n\n.home_butn:hover {\n    background: rgba(255, 255, 255, .3);\n}\n\n.home_butn:active {\n    background: rgba(255, 255, 255, .4);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"home": `SideMenu_home__Hn3Ra`,
	"home_butn": `SideMenu_home_butn__m1XKM`
};
export default ___CSS_LOADER_EXPORT___;
